import axios, { resHandle } from "@/plugins/axios";

/**
 * @description 获取文件列表
 * @param vCom Vue组件
 */
const GetPapers = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/tongue/papers", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 获取文献热点
 * @param vCom Vue组件
 */
const GetTopics = (vCom: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/tongue/paper/topics").then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 文献分析：时间统计、作者图谱
 * @param vCom Vue组件
 */
const GetPaperStats = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/tongue/paper/stats", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 获取文献详情
 * @param vCom Vue组件
 */
const GetPaperDetail = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/tongue/paper", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 获取疾病列表
 * @param vCom Vue组件
 */
const GetDiseases = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/tongue/paper/jbs", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};
export {
    GetPapers,
    GetTopics,
    GetPaperStats,
    GetPaperDetail,
    GetDiseases
};
